import { useState, useEffect, useCallback, useMemo } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useValidateRiskAssessmentContinued } from "../validations/validationHooks/useValidationRiskAssessmentContinued";
import { utilityService } from "../requests/utilityService";
import config from '../components/config';
import useDeligenceStatus from "./useDeligenceStatus";
import { userSession } from "../observers/userObserver";


import { sharedData } from "../sharedData/sharedData";

import { diligenceObservable } from "../observers/deligenceObservable";
import { riskAssesContObservable } from "../observers/riskAssesContObservable";
import {EmailSuccess,EmailFailed,SaveFailureMessage,SaveResultMessages,SaveResponseMessage,ErrorMessage} from "../components/popups/allPopup";
import { reloadAfterValidate } from "../utils/reloadAfterValidate";
import { useEntityId } from "./useEntityId";


export const useRiskAssessmentContinued = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { getDeligenceStatusByCountry } = useDeligenceStatus();
  const locationState = location.state || {};
  
  const ownerId = useMemo(()=>{ return "RiskAssessmentContinued"}, []);
  
  const [searchParams] = useSearchParams();
//   const [Modallabel, setModalLabel] = useState("");
const [modalOpen, setModalOpen] = useState(false);
const [modalHeading, setModalHeading] = useState("");
const showLoader = (message) => {
  setLoadingMessage(message);
  setIsLoading(true);
};

const hideLoader = () => {
  setIsLoading(false);
  setLoadingMessage('');
};
const [isLoading, setIsLoading] = useState(false);
const [loadingMessage, setLoadingMessage] = useState('');

  
  const [formData, setFormData] = useState({
    UKpep: '',
    PepJurisdiction: '',
    PepType: '',
    PepDescription: '',
    Aliases: '',
    SanctionedYear: '',
    sanctionReason: '',
    ReasonDescription: '',
    UKsanctioned: '',
    mitigatingFactors: '',
    FactorDetails: '',
    businessAspects: '',
    genericTerms: '',
    businessUnderstanding: '',
    clarifyResources: '',
    resources: '',
    reason: '',
    ReasonDescribe: '',
    specificInformation: '',
    intendedOutcome: '',
    stepsDetail: '',
    statedBusinessModel: '',
    additionalDetails: '',
    knownCovenant: '',
    operatingYear: '',
    unwillingInformation: '',
    DelayReason: '',
    RequestMissingInfo: '',
    timeframe: '',
    urgencyReason: '',
    urgencyEvent: '',
    adverseInformation: '',
    coverageSource: '',
    coverageDetail: '',
    adversePublicity: '',
    findingsInvestigation: '',
    offenseNature: '',
    OffenceReason: '',
    whiteCollarOffence: '',
    proceedingsVoluntarily: '',
    reputationalConcerns: '',
    subjectAllegations: '',
    AllegationsDetails: ''
  });


  const requestId = useMemo(() => locationState.requestId || sharedData.get("requestId"), []);
  const entityId = useEntityId();
//   const [formData, setFormData] = useState({});
  const [isReadOnly, setIsReadOnly] = useState(
    searchParams.get("readonly") === "true" || searchParams.get("view") === "true"
  );
  const [showSections, setShowSections] = useState((sharedData.get("riskAssesContObservable") || []).filter(i => i.value).map(i => i.by));
  const [loading, setLoading] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [modalLabel, setModalLabel] = useState("");
  const [isRiskAssesmentContinuedCompleted, setIsRiskAssesmentContinuedCompleted] = useState(false);

  const { validateRiskAssesmemntContinued } = useValidateRiskAssessmentContinued();

  const checkIsReadOnly = useCallback((status = undefined) => {
    const isEditMode = searchParams.get("edit") === "true";
    const completed = status === "Validated" || status === "Locked";
    setIsRiskAssesmentContinuedCompleted(completed);
    return completed || searchParams.get("readonly") === "true" || searchParams.get("view") === "true";
  }, [searchParams]);

  useEffect(() => {
    setIsReadOnly(checkIsReadOnly(formData.status));
  }, [formData.status, searchParams, checkIsReadOnly]);

  const fetchRiskAssessmentContinue = useCallback(async () => {
    if (!entityId) return;

    try {
      const token = userSession.getToken();
      const response = await fetch(`${config["backend-url"]}/get_risk_assessment_continued`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ entityId }),
      });

      if (!response.ok) throw new Error("Failed to fetch");

      const data = await response.json();
      localStorage.setItem("riskFormDataContinued", JSON.stringify(data));
      setFormData((prev) => ({ ...prev, ...data }));
      setIsReadOnly(checkIsReadOnly(data.status));

    } catch (err) {
      console.error("Error fetching risk data:", err.message);
    }
  }, [entityId, checkIsReadOnly]);





  const handleSpecialCase = useCallback(async (name, value) => {
    if (name === "PepJurisdiction" || name ==="OffenceReason") {
      const fieldOwnerId = `RiskAssessmentContinued_${name}`;
      diligenceObservable.remove(fieldOwnerId);
      if (value !== "None") {
        const response = await getDeligenceStatusByCountry(value);
        if (response) {
            const hasEnhanced = response.some((item) => item.Diligence.toLowerCase() === "enhanced");
            const hasStandard = response.some((item) => item.Diligence.toLowerCase() === "standard");
            const hasSimplified = response.some((item) => item.Diligence.toLowerCase() === "simplified");
            if (hasEnhanced) {
                diligenceObservable.setValue("Enhanced", fieldOwnerId);
            } else if (hasStandard) {
                diligenceObservable.setValue("Standard", fieldOwnerId);
            } else if (hasSimplified) {
                diligenceObservable.setValue("Simplified", fieldOwnerId);
            }
        }
      }
    }
  }, [getDeligenceStatusByCountry]);

  useEffect(()=>{
    if (formData.mitigatingFactors === "No"){
      diligenceObservable.setValue("Enhanced", "RiskAssessmentContinued mitigatingFactors");
    } else if (formData.mitigatingFactors === "Yes"){
      diligenceObservable.remove("RiskAssessmentContinued mitigatingFactors");
  }}, [formData.mitigatingFactors])

  useEffect(() => {
    if (formData.PepJurisdiction) {
      handleSpecialCase("PepJurisdiction", formData.PepJurisdiction);
    }
    if (formData.OffenceReason) {
      handleSpecialCase("OffenceReason", formData.OffenceReason);
    }
  }, [formData.PepJurisdiction, formData.OffenceReason, handleSpecialCase]);





  const updateRequestPendingAction = useCallback(async (requestId) => {
    const payload = {
      requestId: requestId,
      action: "Yes",
    };
  
    try {
      const token = userSession.getToken();
      const response = await fetch(`${config["backend-url"]}/updateRequestPendingAction`, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json" // ✅ Required for JSON body
        },
        body: JSON.stringify(payload) // ✅ Send the actual payload
      });
  
      const data = await response.json();
  
      if (response.ok) {
        console.log("Update successful:", data);
       
      } else {
        console.error("Failed to update pending action:", data);
      }
    } catch (error) {
      console.error("Error during updateRequestPendingAction:", error);
    }
  }, []);



  

  

  const sendMail = async (userType,question,response) => {
    showLoader('Sending email, please wait...');
    try {
     
      const payload = {
        requestId: requestId,
        userType: userType,
        Modallabel: question,
        response: response,
        Page: "Risk Assessment Continued"  };
       
      
  
      const data = await utilityService.sendMail(payload); // await is optional if you don't need response
      await saveRiskAssessmentContinued(undefined, "Locked");


      if (userType === "MLNO"){
        await updateRequestPendingAction(requestId);
      }
      
      setIsReadOnly(true);
      setFormData((prev) => ({
        ...prev,
        status: "Locked"
      }));


      console.log("✅ Email sent", data);
      setModalLabel(<EmailSuccess />)
      setModalOpen(true)
      setIsModalOpen(false);
          } catch (error) {
      console.error("❌ Failed to send email:", error);
      setModalMessage(<EmailFailed />)
      setModalOpen(true);
   
    }
    hideLoader();
  };


  const saveRiskAssessmentContinued = useCallback(
    async (isValidated = undefined, customStatus = null) => {
      const currentStatus = formData.status;
      const newStatus = customStatus ?? (isValidated ? "Validated" : "Not Validated");
  
      if ((currentStatus === "Validated" || currentStatus === "Locked") && newStatus !== "Locked") return;
  
      setLoading(true);
      try {
        const payload = {
          ...formData,
          entityId,
          status: newStatus,
        };
  
        const response = await fetch(`${config["backend-url"]}/save_risk_assessment_continued`, {
          method: "POST",
          headers: { "Content-Type": "application/json" ,
            "Authorization": `Bearer ${userSession.getToken()}`
          },
          body: JSON.stringify(payload),
        });
  
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error?.error || "Failed to save");
        }
  
        // ✅ Set specific modal label if validated
        const successMsg = newStatus === "Validated"
          ? "Risk Assessment Validated"
          : "Risk Assessment saved successfully.";
        setModalMessage(successMsg);
  
        // setIsEmailModalOpen(true);
        setModalOpen(true);
        await evaluateAndSetDiligence(formData.country);
        setFormData((prev) => ({ ...prev, status: newStatus }));
        setIsReadOnly(checkIsReadOnly(newStatus));
        setHasUnsavedChanges(false);
        if (newStatus === "Validated") {
          reloadAfterValidate();
        }
      } catch (err) {
        setModalMessage(<SaveResponseMessage type="error" message={err.message} />);
        // setIsEmailModalOpen(true);
        setModalOpen(true);
      } finally {
        setLoading(false);
      }
    },
    [entityId, formData, checkIsReadOnly]
  );
  



  const evaluateAndSetDiligence = async (country) => {
    if (country && country !== "None") {
      const response = await getDeligenceStatusByCountry(country);
      if (response) {
        const levels = response.map(r => r.Diligence.toLowerCase());
        if (levels.includes("enhanced")) {
          diligenceObservable.setValue("Enhanced", ownerId);
        } else if (levels.includes("standard")) {
          diligenceObservable.setValue("Standard", ownerId);
        } else if (levels.includes("simplified")) {
          diligenceObservable.setValue("Simplified", ownerId);
        }
      }
    }
  };


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === 'operatingYear') {
      const isCleared = value === "";
      const numericValue = isCleared ? "" : parseInt(value, 10);
      if (isCleared || (!isNaN(numericValue) && numericValue >= 0)) {
        setFormData((prev) => {
          const updatedForm = { ...prev, [name]: numericValue };
          // The report still reads this copy, so it has to move with the form.
          localStorage.setItem("riskFormDataContinued", JSON.stringify(updatedForm));
          return updatedForm;
        });
      }
      if (isCleared) return;
    } else {
      const updatedValue = type === "checkbox" ? checked : value;
      const updatedForm = { ...formData, [name]: updatedValue || "" };
      setFormData(updatedForm);
      localStorage.setItem("riskFormDataContinued", JSON.stringify(updatedForm));
    }
    setHasUnsavedChanges(true);
    handleSpecialCase(e.target.name, e.target.value);
  };

  const handleValidate = async () => {
    // Validate what is actually on screen. The localStorage copy lags behind the
    // form (the operatingYear branch of handleChange never writes it), so validating
    // that snapshot reported filled-in fields as missing.
    const updatedData = { ...formData };
    const errors = validateRiskAssesmemntContinued(updatedData, showSections);
    console.log("errors", errors)

    if (errors) {
      setModalMessage(
        <>
          <h2 style={{ margin: "10px 0", textAlign: "center" }}>
            Validation Result
          </h2>
          <strong>Please fill in the following required fields:</strong>
          <br />
          <div style={{ maxHeight: "200px", overflow: "auto" }}>
            {Object.keys(errors).map((field) => (
              <div key={field}>
                <ul>
                  {errors[field].map((error, index) => (
                    <li key={index}>{error}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </>
      );
      console.log("modal",modalMessage)
      console.log("modal",setModalMessage)

      // setIsEmailModalOpen(true);
      setModalOpen(true);
      return;
    }

    setFormData((prev) => ({ ...prev, status: "Validated" }));
    await saveRiskAssessmentContinued(true);
  };

  const handleNext = useCallback(async () => {
    await saveRiskAssessmentContinued();
    const qs = searchParams.toString();
    const dest = diligenceObservable.isEnhanced() ? "/Edd" : "/FinalReview";
    navigate(`${dest}?${qs}`);
  }, [navigate, saveRiskAssessmentContinued, searchParams]);

  useEffect(() => {
    fetchRiskAssessmentContinue();
    const observableList = sharedData.get("riskAssesContObservable") || [];
      const sections = observableList.filter(i => i.value).map(i => i.by);
      setShowSections(sections);
  }, [fetchRiskAssessmentContinue]);

  return {
    formData,
    setFormData,
    handleChange,
    handleValidate,
    sendMail,
    handleNext,
    saveRiskAssessmentContinued,
    isReadOnly,
    isModalOpen,
    setIsModalOpen,
    isEmailModalOpen,
    setIsEmailModalOpen,
    modalLabel,
    setModalLabel,
    modalMessage,
    loading,
    showSections,
    hasUnsavedChanges,
    isRiskAssesmentContinuedCompleted,
    isLoading,
    loadingMessage,
    modalOpen,
    modalHeading,
    setModalOpen,
    setIsReadOnly
  };
};
